
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M18 3H7a1 1 0 0 0-1 1v7H4.5a1 1 0 0 0 0 2H6v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H8v-6h3.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H8V5h9z"
      }
    }
  ]
})
    }
  